import { render, staticRenderFns } from "./PurchaseRequestDetails.vue?vue&type=template&id=142449ba&scoped=true"
import script from "./PurchaseRequestDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestDetails.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRequestDetails.vue?vue&type=style&index=0&id=142449ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142449ba",
  null
  
)

export default component.exports